<template>
  <nav>
    <v-card height="715" flat color="rgba(0,0,0,0)" style="border-radius: 10px;" class="">
      <v-card class="card1 ml-3 mr-3 mt-2">
        <v-carousel height="270" hide-delimiters :cycle="false">
          <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item"></v-carousel-item>
        </v-carousel>
      </v-card>
      <v-card class="card2 pl-3 pr-3 pb-2">
        
          <center>
            <div style="padding-top: 255px; font-size: 18px;">
              <span class="headline green--text stopflow">{{item_name}}</span>
              <v-divider class="mb-2" />
              <span>Price Marked: </span>
              
              <span class="green--text font-weight-bold">&#8377;{{marked_price}}</span>
							<br/>
							<span>Category: </span>
							<span class="green--text font-weight-bold">{{category}}</span>
            </div>
          </center>
          <br />
          <v-tabs
            slider-color="success"
            grow
            color="grey lighten-3"
            style="border-radius: 10px 10px 0px 0px;"
          >
            <v-tab ripple>Pending</v-tab>
            <v-tab ripple>Accepted</v-tab>
            <v-tab-item>
              <v-card
                flat
                max-height="220"
                min-height="220"
                color="grey lighten-4"
                class="card3 scroll pa-2"
              >
                <center><span v-if="interested.length==0" style="font-size: 16px">You have no pending requests.</span></center>
                <BidBar 
                  v-for="user in sortedArray"
                  :key="user.uid"
                  :user="user"
                  :postId="postId"/>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card
                flat
                max-height="220"
                min-height="220"
                color="grey lighten-4"
                class="card3 scroll pa-2"
              >
                <center><span v-if="accepted.length==0" style="font-size: 16px">You have no accepted requests.</span></center>
                <AcceptedSellBar
                  v-for="user in sortedAccepted"
                  :key="user.uid"
                  :user="user"
                />
              </v-card>
            </v-tab-item>
          </v-tabs>
          <v-layout justify-center row wrap class="mt-2">
            <v-btn flat color="grey darken-2" @click="closePost" round>
              <v-icon small>fas fa-clipboard-check</v-icon>&nbsp; Mark As Sold
            </v-btn>
            <v-spacer/>
            <v-btn flat color="error" @click="deletePost" round>
              <v-icon small>fa fa-trash</v-icon>&nbsp; Delete
            </v-btn>
          </v-layout>
        </v-card>
      </v-card>
      
    
  </nav>
</template>

<script>
import firebase from "firebase";
import BidBar from "@/components/BidBar.vue";
import AcceptedSellBar from "@/components/AcceptedSellBar.vue";
export default {
  components: {
    BidBar,
    AcceptedSellBar
  },
  props: {
    posted_by: Object,
    accepted: Array,
    rejected: Array,
    interested: Array,
    category: String,
    marked_price: Number,
    item_name: String,
    photos: Array,
    postId: String
  },
  methods: {
    deletePost() {
      const db = firebase.firestore();
      var vm = this;
      var index_, index1, index2;
      var accepted = [];
      var interested = [];
      var postDoc = null;
      db.collection("posts_buy")
        .doc(vm.postId)
        .get()
        .then(function(doc) {
          postDoc = doc;
          postDoc.data().accepted.forEach(function(obj) {
            db.collection("users")
              .doc(obj.uid)
              .get()
              .then(function(snap) {
                accepted = snap.data().accepted_buy;
                accepted.forEach(function(element, index) {
                  if (element.id == vm.postId) {
                    index_ = index;
                  }
                });
                accepted.splice(index_, 1);
                db.collection("users")
                  .doc(obj.uid)
                  .update({
                    accepted_buy: accepted
                  })
              })
          });
          postDoc.data().interested.forEach(function(obj1) {
            db.collection("users")
              .doc(obj1.uid)
              .get()
              .then(function(snap1) {
                interested = snap1.data().interested;
                interested.forEach(function(element, index) {
                  if (element.id == vm.postId) {
                    index1 = index;
                  }
                });
                interested.splice(index1, 1);
                db.collection("users")
                  .doc(obj1.uid)
                  .update({
                    interested: interested
                  })
              })
          });
          db.collection("posts_buy")
            .doc(vm.postId)
            .delete()
        })
    },
    closePost() {
      const db = firebase.firestore();
      var vm = this;
      var index_, index1, index2;
      var accepted = [];
      var interested = [];
      var postDoc = null;
      db.collection("posts_buy")
        .doc(vm.postId)
        .get()
        .then(function(doc) {
          postDoc = doc;
          postDoc.data().accepted.forEach(function(obj) {
            db.collection("users")
              .doc(obj.uid)
              .get()
              .then(function(snap) {
                accepted = snap.data().accepted_buy;
                accepted.forEach(function(element, index) {
                  if (element.id == vm.postId) {
                    index_ = index;
                  }
                });
                accepted.splice(index_, 1);
                db.collection("users")
                  .doc(obj.uid)
                  .update({
                    accepted_buy: accepted
                  })
              })
          });
          postDoc.data().interested.forEach(function(obj1) {
            db.collection("users")
              .doc(obj1.uid)
              .get()
              .then(function(snap1) {
                interested = snap1.data().interested;
                interested.forEach(function(element, index) {
                  if (element.id == vm.postId) {
                    index1 = index;
                  }
                });
                interested.splice(index1, 1);
                db.collection("users")
                  .doc(obj1.uid)
                  .update({
                    interested: interested
                  })
              })
          });
          db.collection("posts_buy")
            .doc(vm.postId)
            .update({
              interested: [],
              accepted: [],
              post_closed: true
            })
        })
    }
  },
  data() {
    return {
    };
  },
  computed:{
    sortedArray() {
      var vm=this;
      function compare(a, b) {
        if (a.bid > b.bid)
          return -1;
        if (a.bid < b.bid)
          return 1;
        return 0;
      }
    return vm.interested.sort(compare);
    },
    sortedAccepted() {
      var vm=this;
      function compare(a, b) {
        if (a.bid > b.bid)
          return -1;
        if (a.bid < b.bid)
          return 1;
        return 0;
      }
    return vm.accepted.sort(compare);
    }
  },
  

};
</script>

<style scoped>
.card1 {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  top: 0px;
}
.card2 {
  border-radius: 10px;
  position: relative;
  bottom: 240px;
  z-index: 0;
}
.card3 {
  border-radius: 0px 0px 10px 10px;
  z-index: 0;
}
.scroll {
  overflow-y: auto;
}
.stopflow {
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

</style>